import api from "@/lib/api";
import {
  LineChart, TrendingUp, Twitter, Send, Mail, Link as LinkIcon,
  MessageCircle, Globe, Youtube, Instagram,
} from "lucide-react";

const ICONS = {
  "line-chart": LineChart,
  "trending-up": TrendingUp,
  twitter: Twitter,
  send: Send,
  mail: Mail,
  link: LinkIcon,
  message: MessageCircle,
  globe: Globe,
  youtube: Youtube,
  instagram: Instagram,
};

export default function QuickLinks({ links }) {
  if (!links?.length) return null;

  const onClick = async (e, link) => {
    e.preventDefault();
    try {
      const res = await api.post(`/track/link/${link.id}`);
      window.open(res.data.url, "_blank", "noopener");
    } catch {
      window.open(link.url, "_blank", "noopener");
    }
  };

  return (
    <section className="mt-8">
      <div className="flex items-center justify-between mb-3 px-1">
        <h2 className="font-mono text-[10px] uppercase tracking-[0.2em]" style={{ color: "var(--sb-text-muted)" }}>
          // Quick Links
        </h2>
        <span className="font-mono text-[10px]" style={{ color: "var(--sb-text-muted)" }}>
          {String(links.length).padStart(2, "0")} ENTRIES
        </span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sb-stagger">
        {links.map((l) => {
          const Icon = ICONS[l.icon] || LinkIcon;
          return (
            <a
              key={l.id}
              href={l.url}
              onClick={(e) => onClick(e, l)}
              data-testid={`quick-link-${l.id}`}
              className="sb-card rounded-lg p-4 flex items-center gap-3 group"
            >
              <div
                className="w-9 h-9 rounded-md flex items-center justify-center shrink-0"
                style={{ background: "var(--sb-bg)", border: "1px solid var(--sb-border-subtle)" }}
              >
                <Icon size={16} color="var(--sb-primary)" />
              </div>
              <span className="font-mono text-sm font-medium truncate">{l.label}</span>
              <span
                className="ml-auto font-mono text-[10px] uppercase tracking-wider opacity-60 group-hover:opacity-100"
                style={{ color: "var(--sb-primary)" }}
              >
                Open →
              </span>
            </a>
          );
        })}
      </div>
    </section>
  );
}
